var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVoiceTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.383,
    height: 19.394,
    viewBox: "0 0 20.383 19.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2186",
    "data-name": "Rettangolo 2186",
    width: 20.383,
    height: 19.394
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2155",
    "data-name": "Raggruppa 2155",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3553",
    "data-name": "Tracciato 3553",
    d: "M27.663,198.682a6.751,6.751,0,0,0-6.329,6.679v.176a1.276,1.276,0,0,0,2.548,0v-.224a4.258,4.258,0,0,1,8.472-.576,3.864,3.864,0,0,1,.021.4v.4a1.276,1.276,0,0,0,2.548,0v-.4a6.644,6.644,0,0,0-6.81-6.465Q27.888,198.667,27.663,198.682Z",
    transform: "translate(-17.936 -187.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3554",
    "data-name": "Tracciato 3554",
    d: "M28.1,196.7a4.854,4.854,0,1,0-5.1-4.848A4.977,4.977,0,0,0,28.1,196.7Zm0-7.273a2.427,2.427,0,1,1-2.548,2.424A2.488,2.488,0,0,1,28.1,189.424Z",
    transform: "translate(-17.904 -187)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoiceTarget);
export default __webpack_public_path__ + "static/media/icon-voice-target.a0fee48a9dcfd4a643e7203a453f31d3.svg";
export { ForwardRef as ReactComponent };